import { Subject } from "rxjs/Subject";
import { of } from "rxjs/observable/of";
import { empty } from "rxjs/observable/empty";
import { map, exhaustMap, tap, catchError, takeUntil } from "rxjs/operators";
import { MarketingService } from "./../../services/marketing/marketing.service";
import { UserServiceService } from "./../../services/user-service/user-service.service";
import { environment } from "./../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ErrorHandlerService } from "./../../services/shared/error-handler.service";
import {
  Component,
  NgZone,
  ElementRef,
  ViewChild,
  ViewContainerRef,
  OnInit,
  OnDestroy
} from "@angular/core";
import { LeadActivity, LeadRequest } from "../../dtos/leadActivity.viewmodel";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { LeadStatus } from "../../dtos/leadStatus.viewmodel";
import { Router, ActivatedRoute } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { Gallery, GalleryItem } from "ng-gallery";
import { ProjectsService } from "../../services/projects/projects.service";
import {
  isFutureDateTime,
  removeNullishFieldsParams,
} from "../../shared/object_helpers";
import countries from "../../shared/json/countries";
import { HelpdeskService } from "../../services/helpdesk/helpdesk.service";
import { forkJoin } from "rxjs/observable/forkJoin";
declare var Messenger: any;

@Component({
  selector: "leads",
  templateUrl: "./lead.component.html",
  styleUrls: ["./lead.component.css"]
})
export class LeadsComponent implements OnInit, OnDestroy {
  //#region  Definitions
  private destroy$ = new Subject<void>();
  private submitAction$ = new Subject<{ modal: any, payload: any }>();
  private submitFeedback$ = new Subject<{ modal: any, payload: any }>();

  isFutureDateTime = isFutureDateTime;
  newLeadCount: number = 0;
  documentForm: FormGroup;
  filterForm: FormGroup;
  filterSubmitDisabled = false;
  @ViewChild("fileInput") fileInput: ElementRef;
  @ViewChild("leadExportLogsModal") leadExportLogsModal: any;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));
  title = "lead";

  get canViewExportLogs(): boolean {
    let user = this.userData;
    if (!user) {
      try {
        user = JSON.parse(window.localStorage.getItem("userProfile") || "{}");
      } catch (e) {
        user = {};
      }
    }
    const rawEmail = (
      (user && user.email) ||
      (user && user.user && user.user.email) ||
      ""
    );
    const email = rawEmail.toLowerCase().trim().replace(/\.+$/, "");
    const allowedEmails = [
      "mahmoud.abdelhakim@biographydev.com",
      "fabricasupport@narrativecommunities.com",
      "fabricasupport@biography.com",
      "fabricasupporterp@biography.com",
    ];
    return allowedEmails.includes(email);
  }

  openExportLogsModal() {
    if (this.leadExportLogsModal) {
      this.leadExportLogsModal.open();
    }
  }
  activity: LeadActivity = null;
  reminder: any = {
    title: null,
    details: null,
    reminder_datetime: null,
  };
  request: LeadRequest = null;
  lstatus: LeadStatus = null;
  filterStatus: LeadStatus = null;
  leads = null;
  leadActivities: Array<any> = [];
  status: Array<any> = [];
  reassignTargetId: number | null = null;

  // filter leads
  @ViewChild("leadsContainer") leadsContainer: ElementRef;
  filteredLeads: Array<any> = [];
  loadingFilteredLeads = false;

  leadDetails: any;
  lastFeedbackDisplay: string = "";
  intrestedUnitTypes: any;
  selectedLead: any;
  agents: Array<any> = [];
  documentTypes: Array<any> = [];
  documentType;
  documentNumber;
  documentIssueDate;
  leadId;
  leadDocuments = null;
  documentImageUrls: string[] = [];
  editingLeadDocument: any = null;
  private readonly documentGalleryId = "lead-documents-gallery";
  activityHeading: Array<any> = [];
  activitydetails: Array<any> = [];
  loadingIndicationElement: Element;
  @ViewChild("divscroll") inputs;
  leadStatus: any;
  leadsStatus: any;
  searchLeadsStatus: any;
  pcs: any;
  searchedPcs: any;
  teams: any;
  searchedTeams: any;
  leadChannels: any;
  searchedLeadChannels: any;
  searchLeadSources: any;
  searchedLeadSources: any;
  next_page_url: any;
  selector: string;
  file_name: string;
  isAttachmentDragOver = false;
  fileToUpload: File = null;
  actions: any;
  document: any = {
    type: "",
  };
  uploadExcel: FormGroup;
  lead_source: any = "-1";
  leadSources: Array<any> = [];
  send_to_agent: any = "all";
  agentsArrayString: any = [];
  chosenAgent: any;
  arrSearch: any = [];
  dataFromSearch: any;
  isMarekting = false;
  export_lead: any;
  smsForm: any;
  smsgroup: any;
  emailForm: any;
  channels: any;
  channel: any;
  interest_project: any;
  brokers: any;

  adminComment: any;
  projects: any;
  searchedProjects: any;
  campaigns: any[];
  searchedCampaigns: any[];

  is_collapsed: boolean = true;
  types: any;

  lead_requests: any;
  activitiesForFilter: any;
  searchedActivitiesForFilter: any;

  lead_reminders: any;

  reminders: any;

  readOnlyMode: boolean = false;

  actions_is_collapsed: boolean = true;

  allChecked: boolean = false;
  selectedLeadsID: any[] = [];
  leadsTotal;
  appliedLeadFilters: Record<string, any> = {};
  selectedLeadsCount = 0;
  disableCheckbox: boolean = false;
  formValue;
  allLeadsChecked: boolean = false;
  rotations: any;

  reassignLeadsPayload: any = {
    reassign_user_id: null,
    select_all: false,
    leads_ids: [],
  };
  assign_type: "agent" | "rotation" = "agent";
  rotation_id: any;
  user_ids: any;
  orderTypes: any[] = [
    { id: "updated_at", name: "Last Updated" },
    { id: "created_at", name: "Last Created" },
    { id: "oldest_updated", name: "Oldest Updated" },
  ];
  searchedOrderTypes: any[] = this.orderTypes;
  isLoading: boolean;
  countryCodes: Array<{ dial_code: string; label: string }> = [];
  changeSourceLeadSources: any[] = [];
  searchedChangeSourceLeadSources: any[] = [];

  @ViewChild("logMessageModal") logMessageModal: any;
  @ViewChild("logPhoneCallModal") logPhoneCallModal: any;
  @ViewChild("callQrModal") callQrModal: any;
  meetingTypes: any[];
  searchedMeetingTypes: any[] = [];
  callTypes: any[];
  searchedCallTypes: any[] = [];
  selectedPhoneForQr: string = "";
  callQrCodeUrl: string = "";
  callQrDialUrl: string = "";
  missionTypeOptions: string[] = ["Full Day", "Morning", "Evening"];
  logPhoneCall: any = {
    action_type: "call",
    call_type_id: null,
    due_date: null,
    notes: null,
    has_next_action: false,
  };
  logMessage: any = {
    action_type: "message",
    message_source_id: null,
    due_date: null,
    notes: null,
    has_next_action: false,
  };
  meetingFeedback: any = {
    action_type: "feedback",
    feedback_status_id: null,
    meeting_type_id: null,
    note: null,
    has_next_action: false,
  };
  nextAction: any = {
    next_action: null,
    next_action_meeting_type_id: null,
    next_action_mission_type: null,
    next_action_due_date: null,
    next_action_start_meeting_time: null,
    next_action_end_meeting_time: null,
    next_action_event_type_id: null,
    next_action_event_status_id: null,
    next_action_call_type_id: null,
    next_action_message_source_id: null,
    next_action_feedback_status_id: null,
    next_action_feedback: null,
    next_action_status: null,
    next_action_notes: null,
  };
  setMeeting: any = {
    action_type: "meeting",
    meeting_type_id: null,
    due_date: null,
    event_status_id: null,
    notes: null,
    has_next_action: false,
  };
  feedback: any = {
    action_type: "feedback",
    feedback: null,
    lead_action_id: null,
    event_status_id: null,
    feedback_status_id: null,
    next_action_notes: null,
  };
  nextActions: string[] = ["meeting", "call", "message"];
  firstAction;
  eventStatuses: any;
  lead_id: number;
  messageSources: any;
  searchedMessageSources: any[] = [];
  feedbackStatuses: any;
  searchedFeedbackStatuses: any[] = [];
  phoneFeedbackStatuses: any[];
  messageFeedbackStatuses: any[];
  meetingFeedbackStatuses: any[];
  meetings: any[] = [];
  totalMeetings: number;
  meetingsWithFeedback: any[] = [];
  totalMeetingsWithFeedback: number;
  phoneLogs: any[] = [];
  totalPhoneLogs: number;
  phoneLogsWithFeedback: any[] = [];
  totalPhoneLogsWithFeedback: number;
  messagesLogs: any[] = [];
  totalMessagesLogs: number;
  messagesLogsWithFeedback: any[] = [];
  totalMessagesLogsWithFeedback: number;
  totalTodos: number = 0;
  totalActivities: number;
  edit_action_mode: boolean;
  upload_excel_sheet: any;

  // Feedback visibility flags for past due dates
  showFeedbackInSetMeeting: boolean = false;
  showFeedbackInLogPhoneCall: boolean = false;
  showFeedbackInLogMessage: boolean = false;
  activeTodosActivitySection: "meetings" | "phoneLogs" | "messagesLogs" =
    "meetings";
  activeActivitiesActivitySection: "meetings" | "phoneLogs" | "messagesLogs" =
    "meetings";
  ambassadors: any[];
  private readonly leadFilterKeysForCount: string[] = [
    "filter_name",
    "code",
    "agent_ids",
    "team_id",
    "filter_status",
    "filter_activity",
    "filter_call_type",
    "filter_meeting_type",
    "filter_message_resource",
    "filter_feedback_status",
    "activity_all",
    "filter_channels",
    "lead_actions_due_today",
    "filter_sources",
    "interested_project_id",
    "campaign_id",
    "date_from",
    "date_to",
    "catch_from",
    "catch_to",
    "reminder",
  ];
  //#endregion

  constructor(
    private leadsService: LeadsService,
    private fb: FormBuilder,
    private router: Router,
    private _route: ActivatedRoute,
    vRef: ViewContainerRef,
    private zone: NgZone,
    private helpdeskService: HelpdeskService,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private http: HttpClient,
    private userService: UserServiceService,
    private marketingService: MarketingService,
    private projectService: ProjectsService,
    private route: ActivatedRoute,
    private gallery: Gallery
  ) {
    this.createFilterForm();
    this.countryCodes = this.buildCountryCodeOptions();

    if (["filter_name"].some((f) => this.route.snapshot.queryParams[f])) {
      this.filterForm.patchValue({
        filter_name: this.route.snapshot.queryParams["filter_name"],
      });
      this.onFilterSubmit();
    } else {
      this.getLeads();
    }
    this.export_lead = `${environment.api_base_url
      }leads/export?token=${window.localStorage.getItem("token")}`;
    this.createForm();
    this.activity = new LeadActivity();
    this.request = new LeadRequest();
    this.lstatus = new LeadStatus();
    this.getStatus();
    this.getDocumnetTypes();
    this.getAllActions();
    if (this.userData.role != "Marketing") {
      this.leadSource();
    } else {
      this.leadSources = [
        {
          text: "facebook",
        },
        {
          text: "Youtube",
        },
        {
          text: "Adword",
        },
      ];
      this.isMarekting = true;
    }
    this.getAgents();
    console.log("user role : ", this.userData.role);
    this.marketingService.getChannels().subscribe((response) => {
      const channels = Array.isArray(response) ? response : [];
      this.leadChannels = channels;
      this.searchedLeadChannels = [...channels];
    });
    this.http
      .get(`${environment.api_base_url}settings/sources`)
      .subscribe((data) => {
        const sources = Array.isArray(data) ? data : [];
        this.searchLeadSources = sources;
        this.searchedLeadSources = [...sources];
      });
    //ro stands for readonly, it's intentionaly encrypted so that end user don't bypass it by changing the value from url
    this._route.queryParams.subscribe((params) => {
      this.readOnlyMode = params["ro"] == 1;
    });
  }

  ngOnInit() {
    this.submitAction$.pipe(
      takeUntil(this.destroy$),
      exhaustMap(({ modal, payload }) => {
        return this.leadsService.setAction(this.leadDetails["id"], payload).pipe(
          tap((res: any) => {
            modal.close();
            swal(res.message, "", "success");
            if (res.lead_action.lead_id) {
              this.refreshLeadView(res.lead_action.lead_id);
            }
            if (isFutureDateTime(payload.due_date)) {
              this.reminder.title = payload.action_type;
              this.reminder.lead_action_id = res.lead_action.id;
              this.reminder.details = payload.notes;
              this.reminder.reminder_datetime = payload.due_date;
              this.addReminder();
            }
          }),
          catchError((err) => {
            this.errorHandlerService.handleErorr(err);
            return empty();
          })
        );
      })
    ).subscribe();

    this.submitFeedback$.pipe(
      takeUntil(this.destroy$),
      exhaustMap(({ modal, payload }) => {
        return this.leadsService.setFeedback(this.leadDetails["id"], payload).pipe(
          tap((res: any) => {
            modal.close();
            swal(res.message, "", "success");
            if (res.lead_action.lead_id) {
              this.refreshLeadView(res.lead_action.lead_id);
            }
            if (isFutureDateTime(payload.due_date)) {
              this.reminder.title = payload.action_type;
              this.reminder.lead_action_id = res.lead_action.id;
              this.reminder.details = payload.notes;
              this.reminder.reminder_datetime = payload.due_date;
              this.addReminder();
            }
          }),
          catchError((err) => {
            this.errorHandlerService.handleErorr(err);
            return empty();
          })
        );
      })
    ).subscribe();

    this.getAllReminders();
    this.createSmSBulkForm();
    this.getChannels();
    this.createSmSgroupForm();
    this.createEmailBulkForm();
    this.getAllProjects();
    this.getAllCampaigns();
    this.getNewLeadStatus();
    this.getLeadStatus();
    this.getPcs();
    this.getSubTeams();
    this.getAllRotations();
    this.getBrokers();
    this.getMeetingTypes();
    this.getEventStatuses();
    this.getCallTypes();
    this.getMessageSources();
    this.getFeedbackStatuses();
    this.getAmbassadors();
    this.zone = new NgZone({ enableLongStackTrace: false });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAmbassadors() {
    let params = {
      paginate: false,
    };
    this.userService.getAmbasdors(params).subscribe(
      (data: any) => {
        const ambassadors = Array.isArray(data) ? data : [];
        this.ambassadors = ambassadors;
      },
      (err) => this.errorHandlerService.handleErorr(err),
    );
  }

  getMeetingTypes() {
    this.helpdeskService.getMeetingTypes({
      is_active: true
    }).subscribe(
      (res: any) => {
        const meetingTypes = Array.isArray(res) ? res : [];
        this.meetingTypes = meetingTypes;
        this.searchedMeetingTypes = [...meetingTypes];
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getEventStatuses() {
    this.helpdeskService.getEventStatuses({
      is_active: true
    }).subscribe(
      (res: any) => {
        this.eventStatuses = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getCallTypes() {
    this.helpdeskService.getCallTypes({
      is_active: true
    }).subscribe(
      (res: any) => {
        const callTypes = Array.isArray(res) ? res : [];
        this.callTypes = callTypes;
        this.searchedCallTypes = [...callTypes];
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getMessageSources() {
    this.helpdeskService.getMessageSources({
      is_active: true
    }).subscribe(
      (res: any) => {
        const messageSources = Array.isArray(res) ? res : [];
        this.messageSources = messageSources;
        this.searchedMessageSources = [...messageSources];
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getFeedbackStatuses() {
    this.helpdeskService.getFeedbackStatuses({
      is_active: true
    }).subscribe(
      (res: any) => {
        const feedbackStatuses = Array.isArray(res) ? res : [];
        this.feedbackStatuses = feedbackStatuses;
        this.searchedFeedbackStatuses = [...feedbackStatuses];
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
    this.helpdeskService.getFeedbackStatuses({
      action_type: 'call'
    }).subscribe(
      (res: any) => {
        this.phoneFeedbackStatuses = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
    this.helpdeskService.getFeedbackStatuses({
      action_type: 'message'
    }).subscribe(
      (res: any) => {
        this.messageFeedbackStatuses = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
    this.helpdeskService.getFeedbackStatuses({
      action_type: 'meeting'
    }).subscribe(
      (res: any) => {
        this.meetingFeedbackStatuses = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getAllRotations() {
    this.marketingService.getAllRotations().subscribe(
      (data: any) => {
        this.rotations = Array.isArray(data) ? data : [];
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getPcs() {
    // Use users/get_agents endpoint so returned PCs are scoped by current user role/team.
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        this.pcs = Array.isArray(data) ? data : [];
        this.searchedPcs = [...this.pcs];
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getSubTeams() {
    this.userService.getSubTeams().subscribe(
      (data: any) => {
        this.teams = Array.isArray(data) ? data : [];
        this.searchedTeams = [...this.teams];
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getLeadStatus() {
    console.log("getLeadStatuses");
    this.leadsService.getLeadStatus().subscribe(
      (res: any) => {
        const statuses = Array.isArray(res) ? res : [];
        this.searchLeadsStatus = statuses;
        this.leadsStatus = [...statuses];
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getNewLeadStatus() {
    this.leadsService.getLeadStatuses().subscribe(
      (res: any) => {
        if (res && res.leads_status && res.leads_status.length > 0) {
          let status = res.leads_status.find((a) => a.status == "New");
          if (status) this.newLeadCount = status.count;
        }
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getAllReminders() {
    this.userService.getAllReminders().subscribe(
      (data: any) => {
        this.reminders = Array.isArray(data) ? data : [];
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getLeadReminder(id) {
    this.leadsService.getLeadReminder(id).subscribe(
      (res: any) => {
        this.lead_reminders = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  createFilterForm() {
    this.filterForm = this.fb.group({
      filter_name: [""],
      code: [null],
      filter_consultant: [null],
      agent_ids: [[]],
      team_id: [[]],
      filter_status: [[]],
      filter_activity: [[]],
      filter_call_type: [[]],
      filter_meeting_type: [[]],
      filter_message_resource: [[]],
      filter_feedback_status: [[]],
      activity_all: [null],
      filter_channels: [null],
      lead_actions_due_today: [null],
      filter_sources: [[]],
      order_by: ["created_at"],
      interested_project_id: [null],
      campaign_id: [null],
      date_from: [null],
      date_to: [null],
      catch_from: [null],
      catch_to: [null],
      reminder: [null],
    });
  }
  private buildCountryCodeOptions() {
    const seen = new Set<string>();
    const options = countries.reduce(
      (acc: Array<{ dial_code: string; label: string }>, country: any) => {
        if (!country || !country.dial_code || seen.has(country.dial_code)) {
          return acc;
        }
        seen.add(country.dial_code);
        acc.push({
          dial_code: country.dial_code,
          label: `${country.name} (${country.dial_code})`,
        });
        return acc;
      },
      []
    );
    return options.sort((a, b) => a.label.localeCompare(b.label));
  }

  getLeadRequests(id) {
    this.projectService.getLeadRequests(id).subscribe(
      (res: any) => {
        this.lead_requests = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getLeads() {
    this.route.queryParams.subscribe((params) => {
      // this.reservation_id = +params['id'] || 0;
      if (params.status_id || params.status_name) {
        const statusValue = params.status_name ? [params.status_name] : [];
        this.filterForm.get("filter_status").patchValue(statusValue);
        if (params.channel) {
          let channel = JSON.parse(params.channel);
          this.filterForm.get("filter_channels").patchValue(channel);
        }
        this.onFilterSubmit();
      } else if (params.lead_id) {
        this.getLeadDetails(params.lead_id);
      } else if (params.activity_name) {
        this.filterForm.get("activity_all").patchValue({
          name: params.activity_name,
        });
      }
      const leadId = this._route.snapshot.params["id"] || params.lead_id;
      console.log("this._route.snapshot.params", this._route.snapshot.params);

      this.onFilterSubmit(undefined, leadId);
      this.leadsCheckLastAndLoadNext();
    });
  }

  getAllProjects() {
    this.projectService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => {
        const projects = Array.isArray(data) ? data : [];
        this.projects = [...projects];
        this.searchedProjects = [...projects];
        this.projects.unshift({ id: "", name: "All Projects" });
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getAllCampaigns() {
    this.marketingService.getCampaigns({ paginate: false }).subscribe(
      (data: any) => {
        const campaigns = Array.isArray(data) ? data : [];
        this.campaigns = [...campaigns];
        this.searchedCampaigns = [...campaigns];
        this.campaigns.unshift({ id: "", name: "All Campaigns" });
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onFilterSubmit(paginate_url?, leadId?) {
    this.loadingFilteredLeads = true;
    this.formValue = this.filterForm.value;
    this.setAppliedLeadFiltersSnapshot(this.formValue);
    if (leadId) {
      console.log("leadId", leadId);
      this.leadsService.getLeads().subscribe(
        (respo: any) => {
          this.filteredLeads = respo.data;
          this.leadsTotal = respo.total;

          //Set new key for checkbox
          this.setKeyForCheckbox();

          this.next_page_url = respo.next_page_url;
          this.slimLoadingBarService.complete();
          this.filterSubmitDisabled = false;
          console.log("getting leads from details id.....", leadId);
          this.getLeadDetails(leadId);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
          this.filterSubmitDisabled = false;
        }
      );
    } else if (paginate_url) {
      let page_number = paginate_url.split("page=")[1];
      // console.log(page_number);
      this.formValue = this.filterForm.value;
      this.slimLoadingBarService.start();
      const channelVal = this.formValue.filter_channels
        ? this.formValue.filter_channels
        : "";
      const params = {
        page: page_number,
        keyword: this.formValue.filter_name,
        code: this.formValue.code ? this.formValue.code : "",
        // agent_id: agentVal,
        "agent_ids[]": this.formValue.agent_ids,
        "status[]": this.formValue.filter_status,
        "team_id[]": this.formValue["team_id"],
        "activity[]": this.formValue["filter_activity"],
        "call_type_id[]": this.formValue["filter_call_type"],
        "meeting_type_id[]": this.formValue["filter_meeting_type"],
        "message_source_id[]": this.formValue["filter_message_resource"],
        "feedback_status_id[]": this.formValue["filter_feedback_status"],
        lead_channel_id: channelVal,
        "lead_source[]": this.formValue["filter_sources"],
        order_by: this.formValue.order_by ? this.formValue.order_by : "",
        "interested_project_id[]": this.formValue["interested_project_id"],
        "campaign_id[]": this.formValue["campaign_id"],
        date_from: this.formValue.date_from ? this.formValue.date_from : "",
        date_to: this.formValue.date_to ? this.formValue.date_to : "",
        catch_from: this.formValue.catch_from ? this.formValue.catch_from : "",
        catch_to: this.formValue.catch_to ? this.formValue.catch_to : "",
        lead_actions_due_today: this.formValue.lead_actions_due_today,
        activity_all: this.formValue.activity_all
          ? this.formValue.activity_all.name
          : "",
        reminder: this.formValue.reminder ? this.formValue.reminder : "",
      };
      this.leadsService.getLeads(params).subscribe(
        (respo: any) => {
          this.filteredLeads = this.filteredLeads.concat(respo.data);
          this.leadsTotal = respo.total;

          //Set new key for checkbox
          this.setKeyForCheckbox();

          this.next_page_url = respo.next_page_url;
          this.slimLoadingBarService.complete();
          this.loadingFilteredLeads = false;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
          this.loadingFilteredLeads = false;
        }
      );
    } else {
      this.filterSubmitDisabled = true;
      this.formValue = this.filterForm.value;
      this.slimLoadingBarService.start();
      const channelVal = this.formValue.filter_channels
        ? this.formValue.filter_channels
        : "";
      console.log(this.formValue);
      const params = {
        keyword: this.formValue.filter_name,
        code: this.formValue.code ? this.formValue.code : "",
        // agent_id: agentVal,
        "agent_ids[]": this.formValue.agent_ids,
        "team_id[]": this.formValue["team_id"],
        "status[]": this.formValue["filter_status"],
        "activity[]": this.formValue["filter_activity"],
        "call_type_id[]": this.formValue["filter_call_type"],
        "meeting_type_id[]": this.formValue["filter_meeting_type"],
        "message_source_id[]": this.formValue["filter_message_resource"],
        "feedback_status_id[]": this.formValue["filter_feedback_status"],
        lead_channel_id: channelVal,
        "lead_source[]": this.formValue["filter_sources"],
        order_by: this.formValue.order_by ? this.formValue.order_by : "",
        "interested_project_id[]": this.formValue["interested_project_id"],
        "campaign_id[]": this.formValue["campaign_id"],
        date_from: this.formValue.date_from ? this.formValue.date_from : "",
        date_to: this.formValue.date_to ? this.formValue.date_to : "",
        catch_from: this.formValue.catch_from ? this.formValue.catch_from : "",
        catch_to: this.formValue.catch_to ? this.formValue.catch_to : "",
        lead_actions_due_today: this.formValue.lead_actions_due_today,
        activity_all: this.formValue.activity_all
          ? this.formValue.activity_all.name
          : "",
        reminder: this.formValue.reminder ? this.formValue.reminder : "",
      };
      this.leadsService.getLeads(params).subscribe(
        (respo: any) => {
          this.filteredLeads = respo.data;
          this.leadsTotal = respo.total;

          //Set new key for checkbox
          this.setKeyForCheckbox();

          this.next_page_url = respo.next_page_url;
          this.slimLoadingBarService.complete();
          this.filterSubmitDisabled = false;
          if (respo.data.length !== 0) {
            this.getLeadDetails(this.filteredLeads[0].id);
          }
          this.loadingFilteredLeads = false;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
          this.filterSubmitDisabled = false;
          this.loadingFilteredLeads = false;
        }
      );
    }
  }

  onReset() {
    this.filterForm.reset();
    this.filterForm.patchValue({
      order_by: "updated_at",
    });
    this.onFilterSubmit();
  }

  toggleLeadActionsDueToday() {
    const control = this.filterForm.get("lead_actions_due_today");
    const nextValue = control ? !control.value : true;
    if (control) {
      control.setValue(nextValue);
    }
    this.onFilterSubmit();
  }

  getAllActions() {
    this.slimLoadingBarService.start();
    this.userService.getAllActivites().subscribe(
      (data: any) => {
        this.actions = [...data];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
    this.userService.getAllActivitesForLeadsFilter().subscribe(
      (data: any) => {
        this.activitiesForFilter = [...data];
        this.searchedActivitiesForFilter = this.activitiesForFilter;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  valueChanged(ev) {
    this.chosenAgent = ev;
  }

  leadSource() {
    this.leadSources = null;
    const data = this.leadsService.leadSource();
    this.leadSources = Array.isArray(data) ? data : [];
  }

  createForm() {
    this.file_name = "";
    this.documentForm = this.fb.group({
      id_type: [null, Validators.required],
      file_name: [null],
      file: [null],
    });

    this.uploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
  }

  get is_residence() {
    return this.documentForm.get("is_residence").value;
  }

  handleUploadExcel(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.uploadExcel.get("file").setValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  uploadExcelMethod(modal) {
    const formModel = this.uploadExcel.value;
    if (!formModel.file) {
      swal("Oops...", "Files can not be empty!", "error");
      return;
    } else {
      const data: any = {
        file: formModel.file.value,
        file_name: formModel.file.filename,
        rotation_id: this.rotation_id,
        user_ids: this.user_ids,
      };
      if (this.assign_type == "rotation") {
        delete data.user_ids;
      } else {
        delete data.rotation_id;
      }

      this.slimLoadingBarService.start();
      this.uploadExcelUtility(data, modal);
    }
  }

  uploadExcelUtility(data, modal) {
    this.leadsService.uploadLeadsExcel(data).subscribe(
      (response) => {
        modal.close();
        this.onFilterSubmit();
        this.slimLoadingBarService.complete();
        swal("Woohoo!", "Files uploaded succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }


  onFileChange(event) {
    const file = event instanceof File
      ? event
      : event && event.target && event.target.files
        ? event.target.files[0]
        : null;
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    this.file_name = file.name;
    if (!this.documentForm.get("file_name").value) {
      this.documentForm.get("file_name").setValue(file.name);
    }
    reader.onload = () => {
      this.documentForm
        .get("file")
        .patchValue((reader.result as any as any).split(",")[1]);
    };
  }

  onAttachmentDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isAttachmentDragOver = true;
  }

  onAttachmentDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isAttachmentDragOver = false;
  }

  onAttachmentDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isAttachmentDragOver = false;
    const file = event && event.dataTransfer && event.dataTransfer.files
      ? event.dataTransfer.files[0]
      : null;
    if (file) {
      this.onFileChange(file);
    }
  }

  onDocumentSubmit(modal?: { close: () => void }) {
    this.isLoading = true;
    this.slimLoadingBarService.start();
    const formModel = this.documentForm.value;
    const isEditing = !!(
      this.editingLeadDocument && this.editingLeadDocument.id
    );
    if (!formModel.file && !isEditing) {
      swal("Oops...", "Please upload a file!", "error");
      this.isLoading = false;
      this.slimLoadingBarService.complete();
      return;
    }
    if (isEditing) {
      if (!formModel.file) {
        delete formModel.file;
      }
      formModel.id = this.editingLeadDocument.id;
      this.leadsService.editLeadDocument(this.leadId, formModel).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.slimLoadingBarService.complete();
          this.createForm();
          this.isAttachmentDragOver = false;
          this.editingLeadDocument = null;
          if (modal) {
            modal.close();
          }
          swal("Woohoo!", "Document updated succesfully!", "success");
          this.refreshLeadView();
        },
        error: (err) => {
          this.isLoading = false;
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        },
      })
      return;
    }
    this.leadsService.addLeadDocument(this.leadId, formModel).subscribe(
      (response) => {
        this.isLoading = false;
        this.slimLoadingBarService.complete();
        this.createForm();
        this.isAttachmentDragOver = false;
        this.editingLeadDocument = null;
        if (modal) {
          modal.close();
        }
        swal("Woohoo!", "Document uploaded succesfully!", "success");
        this.refreshLeadView();
      },
      (err) => {
        this.isLoading = false;
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  SmSgroupSendMethod(modal) {
    const payload = this.smsgroup.value;
    if (!this.smsgroup.valid) {
      swal("All Fields are required", "", "error");
    } else {
      this.slimLoadingBarService.start();
      this.marketingService.sendBulkSmSByStatus(payload).subscribe(
        (res: any) => {
          modal.close();
          this.onFilterSubmit();
          swal("Bulk Messages sent successfully", "", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  getMoreLeads() {
    if (this.next_page_url) {
      this.getNextLead();
    }
  }

  getNextLead() {
    this.onFilterSubmit(this.next_page_url);
  }

  addAction(modal) {
    this.slimLoadingBarService.start();
    this.activity.leadId = this.leadId;
    const data = {
      title: this.activity.actionName,
      details: this.activity.actionDescription,
      status: this.activity.status,
      reminder_datetime: this.activity.reminder_datetime,
    };
    this.leadsService.addLeadActivity(this.leadDetails["id"], data).subscribe(
      (res) => {
        this.activity.actionName = "";
        this.activity.actionDescription = "";
        this.refreshLeadView();
        this.slimLoadingBarService.complete();
        this.activity.actionName = null;
        this.activity.actionDescription = "";
        this.activity.reminder_datetime = null;
        this.getNewLeadStatus();
        this.onFilterSubmit(this.next_page_url ? this.next_page_url : null);
        modal.close();
        swal("Woohoo!", "Action created succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getStatus() {
    this.status = null;
    this.status = this.leadsService.status();
  }

  changeStatus(modal?: any) {
    this.slimLoadingBarService.start();

    const data = {
      status: this.lstatus.status,
      reason: this.lstatus.changeResaon,
      reminder_datetime: this.lstatus.status_reminder_datetime,
    };

    this.leadsService.changeLeadStatus(this.leadDetails["id"], data).subscribe(
      (respo) => {
        this.refreshLeadView();
        // this.getLeads();
        // this.onFilterSubmit();
        this.filteredLeads.forEach((lead, index) => {
          if (lead.id == this.leadDetails.id) {
            this.filteredLeads[index].status = this.lstatus.status;
          }
        });
        this.getNewLeadStatus();
        modal.close();
        swal("Woohoo!", "Lead status updated succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  assignCopy() {
    this.filteredLeads = Object.assign([], this.leads);
  }

  getLeadDetails(id) {
    if (isNaN(id)) {
      console.error(
        "tried to use getLeadDetails(id), but the id wasn't a number\nData recieved:",
        id
      );

      return;
    }
    this.leadId = id;
    this.selectedLead = id;
    this.slimLoadingBarService.start();
    this.activeTodosActivitySection = "meetings";
    this.activeActivitiesActivitySection = "meetings";
    this.leadsService.getLeadDetails(id).subscribe(
      (data: any) => {
        this.getLeadReminder(this.leadId);
        console.log(data);
        this.getLeadRequests(id);

        forkJoin([
          this.leadsService
            .getActions(id, "call", { no_feedback: true })
            .pipe(
              catchError((err: any) => {
                console.error("Failed to fetch phone logs", err);
                this.notifyError("Failed to fetch phone logs");
                return of([]);
              })
            ),
          this.leadsService
            .getActions(id, "meeting", { no_feedback: true })
            .pipe(
              catchError((err: any) => {
                console.error("Failed to fetch meeting logs", err);
                this.notifyError("Failed to fetch meeting logs");
                return of([]);
              })
            ),
          this.leadsService
            .getActions(id, "message", { no_feedback: true })
            .pipe(
              catchError((err: any) => {
                console.error("Failed to fetch message logs", err);
                this.notifyError("Failed to fetch message logs");
                return of([]);
              })
            ),
        ]).subscribe(([phoneLogs, meetings, messages]: any[]) => {
          this.phoneLogsWithFeedback = this.getActionsCollection(phoneLogs);
          this.meetingsWithFeedback = this.getActionsCollection(meetings);
          this.messagesLogsWithFeedback = this.getActionsCollection(messages);
          this.totalPhoneLogsWithFeedback = this.phoneLogsWithFeedback.length;
          this.totalMeetingsWithFeedback = this.meetingsWithFeedback.length;
          this.totalMessagesLogsWithFeedback =
            this.messagesLogsWithFeedback.length;
          this.totalTodos =
            this.totalPhoneLogsWithFeedback +
            this.totalMeetingsWithFeedback +
            this.totalMessagesLogsWithFeedback;
          this.syncTodosActivitySection();
        });

        forkJoin([
          this.leadsService
            .getActions(id, "call", { has_feedback: true })
            .pipe(
              catchError((err: any) => {
                console.error("Failed to fetch phone logs", err);
                this.notifyError("Failed to fetch phone logs");
                return of([]);
              })
            ),
          this.leadsService
            .getActions(id, "meeting", { has_feedback: true })
            .pipe(
              catchError((err: any) => {
                console.error("Failed to fetch meeting logs", err);
                this.notifyError("Failed to fetch meeting logs");
                return of([]);
              })
            ),
          this.leadsService
            .getActions(id, "message", { has_feedback: true })
            .pipe(
              catchError((err: any) => {
                console.error("Failed to fetch message logs", err);
                this.notifyError("Failed to fetch message logs");
                return of([]);
              })
            ),
        ]).subscribe(([phoneLogs, meetings, messages]: any[]) => {
          this.phoneLogs = this.getActionsCollection(phoneLogs);
          this.meetings = this.getActionsCollection(meetings);
          this.messagesLogs = this.getActionsCollection(messages);
          this.totalPhoneLogs = this.phoneLogs.length;
          this.totalMeetings = this.meetings.length;
          this.totalMessagesLogs = this.messagesLogs.length;
          this.totalActivities =
            this.totalPhoneLogs + this.totalMeetings + this.totalMessagesLogs;
          this.syncActivitiesActivitySection();
        });

        this.leadDetails = data.lead;
        this.syncLeadInLists(this.leadDetails);
        this.lastFeedbackDisplay = this.formatLastFeedback(
          data && data.lead ? data.lead.last_feedback : null
        );
        this.intrestedUnitTypes = data.interest_unit_types;
        this.lstatus.status = data.lead ? data.lead.status : null;
        this.leadActivities = data.activities;
        this.leadId = data.lead.id;
        this.selectedLead = data.lead.id;
        this.interest_project = data.lead;
        this.resetLeadDocumentImages();
        this.getLeadDocuments(this.leadId);
        this.slimLoadingBarService.complete();
        console.log("Lead intrestedUnitTypes:", this.intrestedUnitTypes);
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  private getLargestActivitySection(counts: {
    meetings: number;
    phoneLogs: number;
    messagesLogs: number;
  }): "meetings" | "phoneLogs" | "messagesLogs" {
    const meetings = counts.meetings || 0;
    const phoneLogs = counts.phoneLogs || 0;
    const messagesLogs = counts.messagesLogs || 0;
    const maxCount = Math.max(meetings, phoneLogs, messagesLogs);

    if (maxCount <= 0) {
      return "meetings";
    }

    if (meetings === maxCount) {
      return "meetings";
    }

    if (phoneLogs === maxCount) {
      return "phoneLogs";
    }

    return "messagesLogs";
  }

  private getActionsCollection(response: any): any[] {
    return response && Array.isArray(response.actions) ? response.actions : [];
  }

  private getNestedValue(source: any, path: string[]): any {
    let current = source;
    for (let i = 0; i < path.length; i++) {
      if (current === null || current === undefined) {
        return undefined;
      }
      current = current[path[i]];
    }
    return current;
  }

  private getPreferredValue(source: any, keys: string[]): any {
    if (!source) {
      return null;
    }

    for (let i = 0; i < keys.length; i++) {
      const value = source[keys[i]];
      if (value !== null && value !== undefined && value !== "") {
        return value;
      }
    }

    return null;
  }

  private refreshLeadView(id?: any) {
    const leadIdToRefresh =
      id ||
      this.leadId ||
      (this.leadDetails && this.leadDetails.id) ||
      this.lead_id;

    if (!leadIdToRefresh || isNaN(leadIdToRefresh)) {
      return;
    }

    this.getLeadDetails(leadIdToRefresh);
  }

  private syncLeadInLists(lead: any) {
    if (!lead || !lead.id) {
      return;
    }

    if (Array.isArray(this.filteredLeads)) {
      this.filteredLeads = this.filteredLeads.map((item) =>
        item && item.id == lead.id ? Object.assign({}, item, lead) : item
      );
    }

    if (Array.isArray(this.leads)) {
      this.leads = this.leads.map((item) =>
        item && item.id == lead.id ? Object.assign({}, item, lead) : item
      );
    }
  }

  private syncTodosActivitySection() {
    this.activeTodosActivitySection = this.getLargestActivitySection({
      meetings: this.totalMeetingsWithFeedback,
      phoneLogs: this.totalPhoneLogsWithFeedback,
      messagesLogs: this.totalMessagesLogsWithFeedback,
    });
  }

  private syncActivitiesActivitySection() {
    this.activeActivitiesActivitySection = this.getLargestActivitySection({
      meetings: this.totalMeetings,
      phoneLogs: this.totalPhoneLogs,
      messagesLogs: this.totalMessagesLogs,
    });
  }

  getLeadMeetingsAction(lead_id: number, params?: any) {
    this.leadsService.getActions(lead_id, "meeting", params).subscribe(
      (res: any) => {
        if (params && params.has_feedback) {
          this.meetings = res.actions || [];
          this.totalMeetings = this.meetings.length;
          this.syncActivitiesActivitySection();
        } else {
          this.meetingsWithFeedback = res.actions || [];
          this.totalMeetingsWithFeedback = this.meetingsWithFeedback.length;
          this.syncTodosActivitySection();
        }
      },
      (err: any) => {
        // this.errorHandlerService.handleErorr(err);
        console.error("Failed to fetch meeting logs", err);
        this.notifyError("Failed to fetch meeting logs");
      }
    );
  }

  getLeadPhoneLogsAction(lead_id: number, params?: any) {
    this.leadsService.getActions(lead_id, "call", params).subscribe(
      (res: any) => {
        if (params && params.has_feedback) {
          this.phoneLogs = res.actions || [];
          this.totalPhoneLogs = this.phoneLogs.length;
          this.syncActivitiesActivitySection();
        } else {
          this.phoneLogsWithFeedback = res.actions || [];
          this.totalPhoneLogsWithFeedback = this.phoneLogsWithFeedback.length;
          this.syncTodosActivitySection();
        }
      },
      (err: any) => {
        // this.errorHandlerService.handleErorr(err);
        console.error("Failed to fetch phone logs", err);
        this.notifyError("Failed to fetch phone logs");
      }
    );
  }

  getMessagesLogsAction(lead_id: number, params?: any) {
    this.leadsService.getActions(lead_id, "message", params).subscribe(
      (res: any) => {
        if (params && params.has_feedback) {
          this.messagesLogs = res.actions || [];
          this.totalMessagesLogs = this.messagesLogs.length;
          this.syncActivitiesActivitySection();
        } else {
          this.messagesLogsWithFeedback = res.actions || [];
          this.totalMessagesLogsWithFeedback = this.messagesLogsWithFeedback.length;
          this.syncTodosActivitySection();
        }
      },
      (err: any) => {
        // this.errorHandlerService.handleErorr(err);
        console.error("Failed to fetch message logs", err);
        this.notifyError("Failed to fetch message logs");
      }
    );
  }

  getActivityDetails(heading) {
    for (let key in this.leadActivities) {
      if (key == heading) {
        const arr = this.leadActivities[heading];
        return arr;
      }
    }
  }

  private addGalleryImage(url?: string | null): void {
    if (!url) {
      return;
    }

    if (this.documentImageUrls.includes(url)) {
      return;
    }

    this.documentImageUrls.push(url);
  }

  private resetLeadDocumentImages(): void {
    this.documentImageUrls = [];
    this.addGalleryImage(
      this.leadDetails ? this.leadDetails.national_url : null
    );
    this.addGalleryImage(
      this.leadDetails ? this.leadDetails.passport_url : null
    );
    this.addGalleryImage(
      this.leadDetails ? this.leadDetails.residence_url : null
    );
  }

  openLeadDocuments(index: number): void {
    if (!this.documentImageUrls.length) {
      return;
    }

    const items: GalleryItem[] = this.documentImageUrls.map((imageUrl) => ({
      src: imageUrl,
      thumbnail: imageUrl,
    }));
    this.gallery.load(items);
    this.gallery.open(index);
  }

  filterLeadObservable = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    if (keyword) {
      return this.http.get(`${baseUrl}users/search?keyword=${keyword}`).pipe(
        map((res: any) => {
          if (res.length == 0) {
            return [];
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.name);
            });
            return this.arrSearch;
          }
        })
      );
    } else {
      return of([]);
    }
  };

  observableSource = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    if (keyword) {
      return this.http.get(`${baseUrl}users/search?keyword=${keyword}`).pipe(
        map((res: any) => {
          if (res.length == 0) {
            return [];
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.name);
            });
            return this.arrSearch;
          }
        })
      );
    } else {
      return of([]);
    }
  };

  getAgents() {
    this.slimLoadingBarService.start();
    this.agents = null;
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        const agents = Array.isArray(data) ? data : [];
        this.agents = agents;
        if (!this.userData.is_sales_team) {
          this.agentsArrayString = [];
          agents.forEach((element) => {
            this.agentsArrayString.push(element.name);
          });
        }
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  deleteLead(id) {
    swal({
      title: "Are you sure?",
      text: "Lead will be deleted!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33"
    }).then((willDelete) => {
      if (willDelete.value) {
        this.slimLoadingBarService.start();
        this.leadsService.delete(id).subscribe(
          (data) => {
            swal("Deleted!", "deleted lead successfully!", "success");
            this.slimLoadingBarService.complete();
            this.leadDetails = null;
            let lead_index;
            this.filteredLeads.forEach((lead, index) => {
              if (lead.id == id) {
                lead_index = index;
              }
            });
            if (lead_index) {
              this.filteredLeads.splice(lead_index, 1);
            }
            this.onFilterSubmit();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
      }
    });
  }

  // confirm(title: string, body: string, confirm: () => any, cancel: () => any) {
  //   this.modal
  //     .confirm().size('sm')
  //     .okBtnClass("btn btn-xs btn-info").cancelBtnClass("btn btn-xs btn-info")
  //     .okBtn("Yes").cancelBtn("No")
  //     .title(title).body(body)
  //     .open().then(val => { val.result.then(res => confirm(), res => cancel()) });
  // }

  notifySuccess(message: string) {
    this.notify(message, "success");
  }

  notifyError(message: string) {
    this.notify(message, "danger");
  }

  notify(message: string, status: string) {
    Messenger().post({
      message: message,
      type: status,
      hideAfter: 5,
      singleton: true,
    });
  }

  editLead(leadId) {
    this.router.navigate(["./pages/addLead", leadId]);
  }

  getDocumnetTypes() {
    this.documentTypes = null;
    this.documentTypes = this.leadsService.getDocumnetTypes();
    this.documentType = "Passport";
  }

  confirmLeadDocument() { }

  getLeadDocuments(id) {
    this.leadsService.getLeadDocuments(id).subscribe(
      (res: any) => {
        const documents = this.normalizeLeadDocuments(res);
        this.leadDocuments = documents;
        this.resetLeadDocumentImages();
        documents.forEach((document) => {
          const url = this.resolveLeadDocumentUrl(document);
          this.addGalleryImage(url);
        });
      },
      (err) => {
        console.error("Failed to fetch lead documents", err);
        this.leadDocuments = [];
      }
    );
  }

  private normalizeLeadDocuments(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }

    if (response && Array.isArray(response.documents)) {
      return response.documents;
    }

    if (response && Array.isArray(response.data)) {
      return response.data;
    }

    if (response && Array.isArray(response.items)) {
      return response.items;
    }

    return [];
  }

  private resolveLeadDocumentUrl(document: any): string | null {
    if (!document) {
      return null;
    }

    const candidate =
      document.full_url ||
      document.url ||
      document.file_url ||
      document.file ||
      document.document_url ||
      document.path ||
      document.value ||
      document.document;

    if (!candidate || typeof candidate !== "string") {
      return null;
    }

    if (candidate.startsWith("http") || candidate.startsWith("data:")) {
      return candidate;
    }

    const baseUrl = environment.api_base_url.endsWith("/")
      ? environment.api_base_url
      : `${environment.api_base_url}/`;
    const normalizedPath = candidate.startsWith("/")
      ? candidate.slice(1)
      : candidate;

    return `${baseUrl}${normalizedPath}`;
  }

  getLeadDocumentUrl(document: any): string | null {
    return this.resolveLeadDocumentUrl(document);
  }

  getLeadDocumentName(document: any): string {
    return (
      this.getPreferredValue(document, [
        "file_name",
        "name",
        "document_name",
        "filename",
        "file",
      ]) ||
      "Document"
    );
  }

  isImageDocument(document: any): boolean {
    const ext = this.getLeadDocumentExtension(document);
    return ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(ext);
  }

  isPdfDocument(document: any): boolean {
    return this.getLeadDocumentExtension(document) === "pdf";
  }

  isExcelDocument(document: any): boolean {
    return ["xls", "xlsx", "csv"].includes(this.getLeadDocumentExtension(document));
  }

  private getLeadDocumentExtension(document: any): string {
    const file =
      this.getPreferredValue(document, [
        "file",
        "file_name",
        "name",
        "document_name",
        "filename",
      ]) || "";
    return this.extractDocumentExtension(file);
  }

  private extractDocumentExtension(value: string): string {
    if (!value || typeof value !== "string") {
      return "";
    }

    const cleaned = value.split("?")[0].split("#")[0];
    const name = cleaned.split("/").pop() || cleaned;
    const parts = name.split(".");
    if (parts.length < 2) {
      return "";
    }

    return parts.pop().toLowerCase();
  }

  get canManageLeadDocuments(): boolean {
    return (
      !this.readOnlyMode &&
      this.userData &&
      this.userData.role != "Legal and Technical" &&
      this.userData.role != "CCO"
    );
  }

  onEditLeadDocument(document: any, modal?: { open: () => void }) {
    this.editingLeadDocument = document;
    this.documentForm.patchValue({
      id_type: document ? document.id_type || null : null,
      file_name: document ? document.file_name || null : null,
      file: null,
    });

    if (modal) {
      modal.open();
    }
  }

  onDeleteLeadDocument(document: any) {
    if (!(document && document.id)) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "You will delete this document!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.leadsService
          .deleteLeadDocument(this.leadId, document.id)
          .subscribe(
            () => {
              swal("Success", "Deleted document successfully", "success");
              this.slimLoadingBarService.complete();
              this.refreshLeadView();
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
              this.slimLoadingBarService.complete();
            }
          );
      }
    });
  }

  onAttachmentModalClose() {
    this.editingLeadDocument = null;
    this.createForm();
  }

  assignToAgent() {
    let agent_id = {
      agent_id: this.leadDetails.agent_id,
    };
    this.slimLoadingBarService.start();
    this.leadsService.assignALead(this.leadId, agent_id).subscribe(
      (data) => {
        this.refreshLeadView();
        this.slimLoadingBarService.complete();
        swal(
          "Cool!",
          "Lead assigned to new property consultant succesfully!",
          "success"
        );
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  exportLead() {
    this.slimLoadingBarService.start();
    this.leadsService.exportLeads().subscribe(
      (data: any) => {
        window.open(data);
        swal("Cool!", "Leads has been exported succesfully!", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  createSmSgroupForm() {
    this.smsgroup = this.fb.group({
      lead_status: ["", Validators.required],
      message: ["", Validators.required],
    });
  }
  createSmSBulkForm() {
    this.smsForm = this.fb.group({
      lead_id: ["", Validators.required],
      message: ["", Validators.required],
      phone: ["", Validators.required],
    });
  }

  createEmailBulkForm() {
    this.emailForm = this.fb.group({
      lead_id: ["", Validators.required],
      subject: ["", Validators.required],
      content: ["", Validators.required],
    });
  }
  openSMSgroupModal(modal) {
    this.createSmSgroupForm();
    modal.open();
  }
  openEmailModal(modal) {
    this.createEmailBulkForm();
    this.emailForm.patchValue({
      lead_id: this.leadDetails.id,
    });
    modal.open();
  }

  openSmMModal(modal) {
    this.createSmSBulkForm();
    this.smsForm.patchValue({
      lead_id: this.leadDetails.id,
      phone: this.leadDetails.phone,
    });
    modal.open();
  }
  SmSgroupFormModalOnClose() {
    this.createSmSgroupForm();
  }
  smsModalOnClose() {
    this.createSmSBulkForm();
  }

  emailModalOnClose() {
    this.createEmailBulkForm();
  }

  sendSmSBulk(modal) {
    const payload = this.smsForm.value;
    if (!this.smsForm.valid) {
      swal("All Fields are required", "", "error");
    } else {
      this.slimLoadingBarService.start();
      this.marketingService.sendSingleSmS(payload).subscribe(
        (res: any) => {
          modal.close();
          this.getLeadDetails(payload.lead_id);
          swal("Message send successfully", "", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  sendEmailBulk(modal) {
    const payload = this.emailForm.value;
    if (!this.emailForm.valid) {
      swal("All Fields are required", "", "error");
    } else {
      this.slimLoadingBarService.start();
      this.marketingService.sendSingleEmail(payload).subscribe(
        (res: any) => {
          modal.close();
          this.getLeadDetails(payload.lead_id);
          swal("Email Sent successfully", "", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = Array.isArray(res) ? res : [];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  channelChange(ev) {
    this.channels.forEach((e) => {
      if (e.name == this.channel) {
        const sources = e && Array.isArray(e.sources) ? e.sources : [];
        this.leadSources = [...sources];
      }
    });
  }

  getBrokers() {
    this.slimLoadingBarService.start();
    this.userService.getBorkers().subscribe(
      (data: any) => {
        this.brokers = Array.isArray(data) ? data : [];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  brokerChange(value) {
    const payload = {
      lead_id: this.leadDetails.id,
      broker_id: value,
    };
    this.slimLoadingBarService.start();
    this.leadsService.updateLeadBroker(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        swal("Broker assigned to the lead successfully.", "", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  exportFilter() {
    this.formValue = this.filterForm.value;
  }

  export() {
    this.slimLoadingBarService.start();
    this.leadsService.exportLeads().subscribe(
      (res: any) => {
        this.channels = res;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  exportFillteredLeads() {
    this.formValue = this.filterForm.value;
    this.slimLoadingBarService.start();
    const channelVal = this.formValue.filter_channels
      ? this.formValue.filter_channels
      : "";
    const fromDateVal = this.formValue.date_from
      ? this.formValue.date_from
      : "";
    const toDateVal = this.formValue.date_to ? this.formValue.date_to : "";
    const fromCatchVal = this.formValue.catch_from
      ? this.formValue.catch_from
      : "";
    const toCatchVal = this.formValue.catch_to ? this.formValue.catch_to : "";
    const reminder = this.formValue.reminder ? this.formValue.reminder : "";

    const params = {
      keyword: this.formValue.filter_name,
      // agent_id: agentVal,
      agent_ids: this.formValue.agent_ids,
      "team_id": this.formValue["team_id"],
      "status[]": this.formValue["filter_status"],
      "activity[]": this.formValue["filter_activity"],
      "call_type_id[]": this.formValue["filter_call_type"],
      "meeting_type_id[]": this.formValue["filter_meeting_type"],
      "message_source_id[]": this.formValue["filter_message_resource"],
      "feedback_status_id[]": this.formValue["filter_feedback_status"],
      lead_channel_id: channelVal,
      "lead_source[]": this.formValue["filter_sources"],
      "interested_project_id[]": this.formValue["interested_project_id"],
      "campaign_id[]": this.formValue["campaign_id"],
      order_by: this.formValue.order_by ? this.formValue.order_by : "",
      date_from: fromDateVal,
      date_to: toDateVal,
      catch_from: fromCatchVal,
      catch_to: toCatchVal,
      reminder: reminder,
      is_export: 1,
    };
    params.agent_ids && (params.agent_ids = params.agent_ids.join(","));
    this.leadsService.getLeads(params).subscribe(
      (data: any) => {
        // this.searchLeadSources = data;
        console.log(data);
        window.open(data.url);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  addAdminComent(modal) {
    console.log(this.adminComment);
    let payload = {
      admin_comment: this.adminComment,
    };
    this.slimLoadingBarService.start();
    this.http
      .put(
        `${environment.api_base_url}leads/${this.leadId}/admin_comment`,
        JSON.stringify(payload)
      )
      .subscribe(
        (res: any) => {
          swal("success", "added admin comment successfully", "success");
          this.slimLoadingBarService.complete();
          this.adminComment = this.leadDetails.admin_comment;
          this.refreshLeadView();
          modal.close();
        },
        (err) => {
          console.log(err);
          this.slimLoadingBarService.reset();
        }
      );
  }

  addRequest() {
    console.log(this.request);
    let payload = {
      project_id: this.request.project_id,
      unit_type_id: this.request.unit_type,
      country: this.request.country,
      governorate: this.request.governorate,
      district: this.request.district,
      delivery_date: this.request.delivery_date,
      budget_from: this.request.total_budget_from,
      budget_to: this.request.total_budget_to,
      down_payment_from: this.request.down_payment_from,
      down_payment_to: this.request.down_payment_to,
      installments_from: this.request.monthly_installments_from,
      installments_to: this.request.monthly_installments_to,
      unit_area_from: this.request.unit_area_from,
      unit_area_to: this.request.unit_area_to,
    };
    this.slimLoadingBarService.start();
    this.projectService.addLeadRequest(this.leadDetails.id, payload).subscribe(
      (res: any) => {
        this.getLeadRequests(this.leadDetails.id);
        this.slimLoadingBarService.complete();
        this.request = new LeadRequest();
        swal("Sucecss", "Added request successfully", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  onProjectChange(event) {
    console.log(this.request.project_id);
    this.getUnitTypes(this.request.project_id);
  }

  getUnitTypes(project_id) {
    this.slimLoadingBarService.start();
    this.projectService.getUnitTypes(project_id).subscribe(
      (data) => {
        this.types = Array.isArray(data) ? data : [];
        console.log(this.types);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  leadHadMeeting() {
    swal({
      title: "Are you sure?",
      text: "indoor a meeting!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reserve it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.leadsService.indoorMeeting(this.leadDetails.id).subscribe(
          (data) => {
            console.log(data);
            swal("success", "Indoor Meeting successfully", "success");
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  addReminder() {
    this.slimLoadingBarService.start();
    const data = {
      title: this.reminder.title,
      details: this.reminder.details,
      reminder_datetime: this.reminder.reminder_datetime,
    };
    console.log(data);
    this.leadsService.addLeadReminder(this.leadDetails["id"], data).subscribe(
      (res) => {
        this.reminder = {
          title: null,
          details: null,
          reminder_datetime: null,
        };
        this.getLeadReminder(this.leadId);
        this.slimLoadingBarService.complete();
        swal("Woohoo!", "Reminder created succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onReminderChange(event, rem) {
    this.slimLoadingBarService.start();
    this.leadsService.toggleReminderRead(rem.id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  //Set new key for checkbox
  setKeyForCheckbox() {
    this.filteredLeads.forEach((element) => {
      if (this.allChecked == true) {
        element.checked = true;
      } else {
        element.checked = false;
      }
    });
    this.updateSelectedCount();
  }

  updateAllComplete() {
    this.allChecked =
      this.filteredLeads != null &&
      this.filteredLeads.every((lead) => lead.checked);
    this.updateSelectedCount();
  }

  someComplete(): boolean {
    if (this.filteredLeads == null) {
      return false;
    }
    return (
      this.filteredLeads.filter((lead) => lead.checked).length > 0 &&
      !this.allChecked
    );
  }

  setAll(checked: boolean) {
    this.allChecked = checked;

    if (this.filteredLeads == null) {
      return;
    }
    this.filteredLeads.forEach((lead) => (lead.checked = checked));
    this.updateSelectedCount();
  }

  selectAllLeads(checked: boolean) {
    this.disableCheckbox = checked;
    this.allLeadsChecked = checked;

    if (this.filteredLeads == null) {
      return;
    }
    this.allChecked = false;
    this.filteredLeads.forEach((lead) => (lead.checked = false));

    if (checked) {
      this.selectedLeadsCount = this.leadsTotal;
      this.reassignLeadsPayload.select_all = true;
    } else {
      this.selectedLeadsCount = 0;
      this.reassignLeadsPayload.select_all = false;
      this.setNull(this.reassignLeadsPayload);
    }
  }

  updateSelectedCount() {
    this.selectedLeadsCount = this.filteredLeads.filter(
      (lead) => lead.checked == true
    ).length;
  }


  reassignLeadsModalOpen(modal, id: number = null) {
    if (id) {
      this.reassignLeadsPayload.leads_ids = [id];
    } else {
      this.selectedLeadsID = this.filteredLeads
        .filter((lead) => lead.checked == true)
        .map((lead) => lead.id);
      this.reassignLeadsPayload.leads_ids = this.selectedLeadsID;
    }
    if (this.allLeadsChecked) {
      this.reassignLeadsPayload.select_all = true;
    }

    if (this.disableCheckbox) {
      this.reassignLeadsPayload = {
        ...this.reassignLeadsPayload,
        ...this.formValue,
      };
    }

    console.log(this.reassignLeadsPayload);

    if (
      this.reassignLeadsPayload.leads_ids.length < 1 &&
      !this.reassignLeadsPayload.select_all
    ) {
      swal({
        title: "There is no selected leads",
        text: "You have to select leads first!!",
        type: "warning",
        showCancelButton: false,
        confirmButtonText: "Go, select leads first!",
      }).then((result) => {
        modal.close();
      });
    }
  }

  reassignLeadsModalClose(modal) {
    this.setNull(this.reassignLeadsPayload);
    this.setNull(this.reassignTargetId);
    modal.close();
  }

  private buildBulkChangeSourceFilters() {
    this.formValue = this.filterForm.value;
    const channelVal = this.formValue.filter_channels
      ? this.formValue.filter_channels
      : "";
    return removeNullishFieldsParams({
      keyword: this.formValue.filter_name,
      code: this.formValue.code ? this.formValue.code : "",
      agent_ids: this.formValue.agent_ids,
      team_id: this.formValue["team_id"],
      status: this.formValue["filter_status"],
      activity: this.formValue["filter_activity"],
      call_type_id: this.formValue["filter_call_type"],
      meeting_type_id: this.formValue["filter_meeting_type"],
      message_source_id: this.formValue["filter_message_resource"],
      feedback_status_id: this.formValue["filter_feedback_status"],
      lead_channel_id: channelVal,
      lead_source: this.formValue["filter_sources"],
      order_by: this.formValue.order_by ? this.formValue.order_by : "",
      interested_project_id: this.formValue["interested_project_id"],
      campaign_id: this.formValue["campaign_id"],
      date_from: this.formValue.date_from ? this.formValue.date_from : "",
      date_to: this.formValue.date_to ? this.formValue.date_to : "",
      catch_from: this.formValue.catch_from ? this.formValue.catch_from : "",
      catch_to: this.formValue.catch_to ? this.formValue.catch_to : "",
      lead_actions_due_today: this.formValue.lead_actions_due_today,
      activity_all: this.formValue.activity_all
        ? this.formValue.activity_all.name
        : "",
      reminder: this.formValue.reminder ? this.formValue.reminder : "",
    });
  }

  reassignLeadsModalSubmit(modal) {
    if (
      !this.reassignLeadsPayload.reassign_user_id &&
      !this.reassignLeadsPayload.rotation_id
    ) {
      swal("Please select agent and rotation", "", "error");
      return;
    }
    swal({
      title: "Are you sure?",
      text: "You are about to do an actions over multiple leads!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Do it!",
      cancelButtonText: "No.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.formValue = this.filterForm.value;
        this.slimLoadingBarService.start();
        console.log(this.formValue.filter_status);
        // this.reassignLeadsPayload.status =
        //   this.formValue.filter_status && this.formValue.filter_status.length
        //     ? this.formValue.filter_status.map((el) => el).join(",")
        //     : "";
        this.reassignLeadsPayload.status = this.formValue.filter_status
          ? this.formValue.filter_status
          : "";
        // this.reassignLeadsPayload.activity =
        //   this.formValue.filter_activity &&
        //   this.formValue.filter_activity.length
        //     ? this.formValue.filter_activity.map((el) => el).join(",")
        //     : "";
        this.reassignLeadsPayload.activity = this.formValue.filter_activity
          ? this.formValue.filter_activity
          : "";
        this.reassignLeadsPayload.call_type_id = this.formValue.filter_call_type
          ? this.formValue.filter_call_type
          : "";
        this.reassignLeadsPayload.meeting_type_id = this.formValue.filter_meeting_type
          ? this.formValue.filter_meeting_type
          : "";
        this.reassignLeadsPayload.message_source_id = this.formValue.filter_message_resource
          ? this.formValue.filter_message_resource
          : "";

        if (
          this.reassignLeadsPayload.lead_channel_id == null ||
          this.reassignLeadsPayload.lead_channel_id === ""
        ) {
          this.reassignLeadsPayload.lead_channel_id = this.formValue
            .filter_channels
            ? this.formValue.filter_channels
            : "";
        }

        // this.reassignLeadsPayload.lead_source =
        //   this.formValue.filter_sources && this.formValue.filter_sources.length
        //     ? this.formValue.filter_sources.map((el) => el.name).join(",")
        //     : "";
        if (
          this.reassignLeadsPayload.lead_source == null ||
          this.reassignLeadsPayload.lead_source === ""
        ) {
          this.reassignLeadsPayload.lead_source = this.formValue.filter_sources
            ? this.formValue.filter_sources
            : "";
        }
        this.reassignLeadsPayload.lead_event_id = this.formValue.lead_event_id
          ? this.formValue.lead_event_id.id
          : "";
        this.reassignLeadsPayload.qualified_feedback_status = this.formValue
          .qualified_feedback_status
          ? this.formValue.qualified_feedback_status.id
          : "";

        this.reassignLeadsPayload.lead_campaign_id = this.formValue
          .lead_campaign_id
          ? this.formValue.lead_campaign_id
          : "";

        this.reassignLeadsPayload.team_id = this.formValue.team_id
          ? this.formValue.team_id.id
          : "";
        this.reassignLeadsPayload.interested_project_id = this.formValue
          .interested_project_id
          ? this.formValue.interested_project_id
          : "";
        this.reassignLeadsPayload.campaign_id = this.formValue.campaign_id
          ? this.formValue.campaign_id
          : "";
        this.reassignLeadsPayload.date_from = this.formValue.date_from
          ? this.formValue.date_from
          : "";
        this.reassignLeadsPayload.date_to = this.formValue.date_to
          ? this.formValue.date_to
          : "";
        this.reassignLeadsPayload.catch_from = this.formValue.catch_from
          ? this.formValue.catch_from
          : "";
        this.reassignLeadsPayload.catch_to = this.formValue.catch_to
          ? this.formValue.catch_to
          : "";
        this.reassignLeadsPayload.reminder = this.formValue.reminder
          ? this.formValue.reminder
          : "";
        this.reassignLeadsPayload.keyword = this.formValue.filter_name;
        this.reassignLeadsPayload.activity_all = this.formValue.activity_all
          ? this.formValue.activity_all.name
          : "";
        for (let key in this.reassignLeadsPayload) {
          if (this.reassignLeadsPayload[key] == null)
            delete this.reassignLeadsPayload[key];
        }
        if (this.assign_type == "agent") {
          delete this.reassignLeadsPayload.rotation_id;
        } else {
          delete this.reassignLeadsPayload.reassign_user_id;
        }
        delete this.reassignLeadsPayload.order_by;
        this.leadsService.reassignAllLeads(this.reassignLeadsPayload).subscribe(
          (data) => {
            this.allLeadsChecked = false;
            this.selectAllLeads(false);

            //Set all object key to null after submission
            this.setNull(this.reassignLeadsPayload);
            this.setNull(this.reassignTargetId);

            modal.close();

            this.getLeads();

            this.slimLoadingBarService.complete();

            swal(
              "Cool!",
              "Leads assigned to new agent succesfully!",
              "success"
            );
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.reset();
          },
          () => this.slimLoadingBarService.complete()
        );
      }
    });
  }

  changeSourceLeadsModalSubmit(modal) {
    if (
      !this.reassignLeadsPayload.lead_channel_id ||
      !this.reassignLeadsPayload.lead_source
    ) {
      swal("Please select channel and source", "", "error");
      return;
    }
    swal({
      title: "Are you sure?",
      text: "You are about to do an actions over multiple leads!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Do it!",
      cancelButtonText: "No.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        const payload = removeNullishFieldsParams({
          // filters: this.buildBulkChangeSourceFilters(),
          leads_ids: this.reassignLeadsPayload.leads_ids,
          select_all: this.reassignLeadsPayload.select_all,
          change_lead_source: this.reassignLeadsPayload.lead_source,
          change_lead_channel_id: this.reassignLeadsPayload.lead_channel_id,
          change_broker_id: this.reassignLeadsPayload.change_broker_id,
          change_ambassador_id: this.reassignLeadsPayload.change_ambassador_id,
          change_reason: this.reassignLeadsPayload.reason,
        });
        this.leadsService.bulkChangeSource(payload).subscribe(
          () => {
            this.allLeadsChecked = false;
            this.selectAllLeads(false);

            //Set all object key to null after submission
            this.setNull(this.reassignLeadsPayload);
            this.setNull(this.reassignTargetId);

            modal.close();

            this.getLeads();

            this.slimLoadingBarService.complete();

            swal("Cool!", "Leads source updated succesfully!", "success");
            this.getLeads();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.reset();
          },
          () => this.slimLoadingBarService.complete()
        );
      }
    });
  }

  //Set all object key to null after submission #45897879 stackoverflow
  setAllKeys(obj, val) {
    if (!obj) {
      return;
    }
    Object.keys(obj).forEach(function (index) {
      obj[index] = val;
    });
  }

  setNull(obj) {
    this.setAllKeys(obj, null);
  }

  // leads scroll

  ngAfterViewInit() {
    this.leadsContainer.nativeElement.addEventListener(
      "scroll",
      this.leadsCheckLastAndLoadNext.bind(this)
    );
  }

  leadsCheckLastAndLoadNext() {
    if (
      !this.loadingFilteredLeads &&
      this.leadsContainer.nativeElement.scrollHeight -
      this.leadsContainer.nativeElement.scrollTop -
      this.leadsContainer.nativeElement.clientHeight <
      10 &&
      this.next_page_url
    ) {
      this.getMoreLeads();
    }
  }

  searchLeadsStatusHandler(searchLeadsStatusInput) {
    this.leadsStatus = this.searchLeadsStatus.filter((status) => {
      return status
        .toLowerCase()
        .includes(searchLeadsStatusInput.toLowerCase());
    });
  }

  searchPcsHandler(searchPcsInput) {
    this.searchedPcs = this.pcs.filter((pc) => {
      return pc.name.toLowerCase().includes(searchPcsInput.toLowerCase());
    });
  }

  searchTeamsHandler(searchPcsInput) {
    this.searchedTeams = this.teams.filter((team) => {
      return team.name.toLowerCase().includes(searchPcsInput.toLowerCase());
    });
  }

  searchLeadChannelsHandler(searchLeadChannelInput) {
    this.searchedLeadChannels = this.channels.filter((channel) => {
      return channel.name
        .toLowerCase()
        .includes(searchLeadChannelInput.toLowerCase());
    });
  }

  searchLeadSourcesHandler(searchLeadSourceInput) {
    this.searchedLeadSources = this.searchLeadSources.filter((source) => {
      return source.name
        .toLowerCase()
        .includes(searchLeadSourceInput.toLowerCase());
    });
  }

  changeSourceChannelChange(channelId) {
    this.reassignLeadsPayload.lead_source = null;
    if (!channelId) {
      this.changeSourceLeadSources = [];
      this.searchedChangeSourceLeadSources = [];
      return;
    }
    const selectedChannel = this.channels.find(
      (channel) => channel.id == channelId
    );
    const sources =
      selectedChannel && Array.isArray(selectedChannel.sources)
        ? selectedChannel.sources
        : [];
    this.changeSourceLeadSources = [...sources];
    this.searchedChangeSourceLeadSources = [...sources];
  }

  searchChangeSourceLeadSourcesHandler(searchLeadSourceInput) {
    this.searchedChangeSourceLeadSources = this.changeSourceLeadSources.filter(
      (source) => {
        return source.name
          .toLowerCase()
          .includes(searchLeadSourceInput.toLowerCase());
      }
    );
  }

  searchProjectsHandler(searchProjectInput) {
    this.searchedProjects = this.projects.filter((project) => {
      return project.name
        .toLowerCase()
        .includes(searchProjectInput.toLowerCase());
    });
  }

  searchOrderTypesHandler(searchOrderTypeInput) {
    this.searchedOrderTypes = this.orderTypes.filter((orderType) => {
      return orderType.name
        .toLowerCase()
        .includes(searchOrderTypeInput.toLowerCase());
    });
  }

  searchCampaignsHandler(searchCampaignInput) {
    this.searchedCampaigns = this.campaigns.filter((campaign) => {
      return campaign.name
        .toLowerCase()
        .includes(searchCampaignInput.toLowerCase());
    });
  }

  searchActivityHandler(searchActivityInput) {
    this.searchedActivitiesForFilter = this.activitiesForFilter.filter(
      (activity) => {
        return activity
          .toLowerCase()
          .includes(searchActivityInput.toLowerCase());
      }
    );
  }

  searchCallTypesHandler(searchCallTypeInput) {
    const normalizedInput = (searchCallTypeInput || "").toLowerCase();
    this.searchedCallTypes = (this.callTypes || []).filter((callType) => {
      const callTypeName =
        callType && typeof callType.name === "string"
          ? callType.name.toLowerCase()
          : "";
      return callTypeName.includes(normalizedInput);
    });
  }

  searchMeetingTypesHandler(searchMeetingTypeInput) {
    const normalizedInput = (searchMeetingTypeInput || "").toLowerCase();
    this.searchedMeetingTypes = (this.meetingTypes || []).filter(
      (meetingType) => {
        const meetingTypeName =
          meetingType && typeof meetingType.name === "string"
            ? meetingType.name.toLowerCase()
            : "";
        return meetingTypeName.includes(normalizedInput);
      }
    );
  }

  searchMessageResourcesHandler(searchMessageResourceInput) {
    const normalizedInput = (searchMessageResourceInput || "").toLowerCase();
    this.searchedMessageSources = (this.messageSources || []).filter(
      (messageResource) => {
        const messageSourceName =
          messageResource && typeof messageResource.name === "string"
            ? messageResource.name.toLowerCase()
            : "";
        return messageSourceName.includes(normalizedInput);
      }
    );
  }

  searchFeedbackStatusesHandler(searchFeedbackStatusInput) {
    const normalizedInput = (searchFeedbackStatusInput || "").toLowerCase();
    this.searchedFeedbackStatuses = (this.feedbackStatuses || []).filter(
      (feedbackStatus) => {
        const feedbackStatusName =
          feedbackStatus && typeof feedbackStatus.name === "string"
            ? feedbackStatus.name.toLowerCase()
            : "";
        return feedbackStatusName.includes(normalizedInput);
      }
    );
  }

  get hasAppliedLeadFilters(): boolean {
    return this.leadFilterKeysForCount.some((key) =>
      this.isLeadFilterValueApplied(this.appliedLeadFilters[key])
    );
  }

  private setAppliedLeadFiltersSnapshot(formValue: any): void {
    const snapshot: Record<string, any> = {};
    this.leadFilterKeysForCount.forEach((key) => {
      snapshot[key] = formValue ? formValue[key] : undefined;
    });
    this.appliedLeadFilters = snapshot;
  }

  private isLeadFilterValueApplied(value: any): boolean {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === "string") {
      return value.trim().length > 0;
    }
    if (typeof value === "boolean") {
      return value;
    }
    if (value && typeof value === "object") {
      const idValue = value.id;
      if (idValue !== undefined) {
        return idValue !== null && idValue !== "";
      }
      const nameValue = value.name;
      if (typeof nameValue === "string") {
        return nameValue.trim().length > 0;
      }
      return Object.keys(value).length > 0;
    }
    return value !== null && value !== undefined && value !== "";
  }

  private normalizeLastFeedbackSegment(value: any): string {
    if (value === null || value === undefined) {
      return "";
    }

    if (typeof value === "string") {
      return value.trim();
    }

    if (typeof value === "number" || typeof value === "boolean") {
      return String(value);
    }

    if (typeof value === "object") {
      if (typeof value.name === "string") {
        return value.name.trim();
      }
      if (typeof value.title === "string") {
        return value.title.trim();
      }
      if (typeof value.text === "string") {
        return value.text.trim();
      }
      if (typeof value.label === "string") {
        return value.label.trim();
      }
      return "";
    }

    return String(value).trim();
  }

  private inferLastFeedbackActionType(lastFeedback: any): string {
    const inferredActionTypeByMeta =
      this.normalizeLastFeedbackSegment(
        this.getNestedValue(lastFeedback, ["lead_action", "action_type"]) ||
        this.getNestedValue(lastFeedback, ["last_action", "action_type"]) ||
        this.getNestedValue(lastFeedback, ["related_action", "action_type"])
      ).toLowerCase() || "";

    if (inferredActionTypeByMeta) {
      return inferredActionTypeByMeta;
    }

    const explicitType = this.normalizeLastFeedbackSegment(
      (lastFeedback && lastFeedback.action_type) ||
      (lastFeedback && lastFeedback.activity_type) ||
      (lastFeedback && lastFeedback.type) ||
      this.getNestedValue(lastFeedback, ["action", "type"])
    ).toLowerCase();

    if (
      lastFeedback &&
      (lastFeedback.call_type ||
        lastFeedback.call_type_id ||
        lastFeedback.call_type_name)
    ) {
      return "call";
    }

    if (
      lastFeedback &&
      (lastFeedback.meeting_type ||
        lastFeedback.meeting_type_id ||
        lastFeedback.meeting_type_name)
    ) {
      return "meeting";
    }

    if (
      lastFeedback &&
      (lastFeedback.message_source ||
        lastFeedback.message_source_id ||
        lastFeedback.message_source_name ||
        lastFeedback.message_type ||
        lastFeedback.message_type_id ||
        lastFeedback.message_type_name)
    ) {
      return "message";
    }

    if (explicitType) {
      return explicitType;
    }

    return "";
  }

  private normalizeLastFeedbackActionLabel(actionType: string): string {
    const normalized = (actionType || "").toLowerCase().trim();
    if (!normalized) {
      return "";
    }

    if (normalized.includes("call") || normalized.includes("phone")) {
      return "Call";
    }

    if (normalized.includes("meeting")) {
      return "Meeting";
    }

    if (
      normalized.includes("message") ||
      normalized.includes("msg") ||
      normalized.includes("whatsapp")
    ) {
      return "Message";
    }

    return normalized
      .split(/[\s_-]+/)
      .filter(Boolean)
      .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
      .join(" ");
  }

  private getLastFeedbackActionSubType(
    lastFeedback: any,
    actionType: string
  ): string {
    const normalizedActionType = (actionType || "").toLowerCase();
    const callType = this.normalizeLastFeedbackSegment(
      this.getNestedValue(lastFeedback, ["call_type", "name"]) ||
      (lastFeedback && lastFeedback.call_type_name) ||
      (lastFeedback && lastFeedback.call_type)
    );
    const meetingType = this.normalizeLastFeedbackSegment(
      this.getNestedValue(lastFeedback, ["meeting_type", "name"]) ||
      (lastFeedback && lastFeedback.meeting_type_name) ||
      (lastFeedback && lastFeedback.meeting_type)
    );
    const messageType = this.normalizeLastFeedbackSegment(
      this.getNestedValue(lastFeedback, ["message_source", "name"]) ||
      (lastFeedback && lastFeedback.message_source_name) ||
      (lastFeedback && lastFeedback.message_source) ||
      this.getNestedValue(lastFeedback, ["message_type", "name"]) ||
      (lastFeedback && lastFeedback.message_type_name) ||
      (lastFeedback && lastFeedback.message_type)
    );

    if (normalizedActionType === "call") {
      return callType;
    }

    if (normalizedActionType === "meeting") {
      return meetingType;
    }

    if (normalizedActionType === "message") {
      return messageType;
    }

    return callType || meetingType || messageType || "";
  }

  private formatLastFeedback(lastFeedback: any): string {
    if (lastFeedback === null || lastFeedback === undefined) {
      return "";
    }

    if (typeof lastFeedback === "string") {
      const normalized = lastFeedback.trim();
      if (!normalized) {
        return "";
      }
      if (normalized.startsWith("[") && normalized.endsWith("]")) {
        return normalized;
      }
      return `[ ${normalized} ]`;
    }

    if (typeof lastFeedback !== "object") {
      const normalized = String(lastFeedback).trim();
      return normalized ? `[ ${normalized} ]` : "";
    }

    const actionType = this.normalizeLastFeedbackActionLabel(
      this.inferLastFeedbackActionType(lastFeedback)
    );
    const actionSubType = this.getLastFeedbackActionSubType(
      lastFeedback,
      actionType
    );
    const feedbackStatus = this.normalizeLastFeedbackSegment(
      (lastFeedback && lastFeedback.feedback_status) ||
      (lastFeedback && lastFeedback.feedback_status_name)
    );
    const feedback = this.normalizeLastFeedbackSegment(
      lastFeedback && lastFeedback.feedback
    );
    const note = this.normalizeLastFeedbackSegment(
      (lastFeedback && lastFeedback.note) ||
      (lastFeedback && lastFeedback.notes) ||
      (lastFeedback && lastFeedback.next_action_notes) ||
      (lastFeedback && lastFeedback.comment)
    );

    const requiredSegments = [
      actionType || "-",
      actionSubType || "-",
      feedbackStatus || "-",
      feedback || "-",
    ];

    const hasMeaningfulValue =
      requiredSegments.some((segment) => segment !== "-") || !!note;
    if (!hasMeaningfulValue) {
      return "";
    }

    const segments = note ? [...requiredSegments, note] : requiredSegments;
    return `[ ${segments.join(" / ")} ]`;
  }

  private toLocalDatetimeLocal(isoOrDate: string | Date): string {
    const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
    // HTML datetime-local ignores seconds; trim them for cleanliness
    d.setSeconds(0, 0);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  deleteLeadAction(actionId: number) {
    if (!actionId) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "This lead action will be deleted.",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (!(result && result.value)) {
        return;
      }
      this.slimLoadingBarService.start();
      this.leadsService.deleteLeadActions(actionId).subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          swal(
            "Deleted!",
            (res && res.message) || "Lead action deleted successfully.",
            "success"
          );
          this.refreshLeadView();
        },
        (err: any) => {
          this.slimLoadingBarService.complete();
          this.errorHandlerService.handleErorr(err);
        }
      );
    });
  }

  setActiveTodosActivitySection(
    section: "meetings" | "phoneLogs" | "messagesLogs"
  ) {
    this.activeTodosActivitySection = section;
  }

  setActiveActivitiesActivitySection(
    section: "meetings" | "phoneLogs" | "messagesLogs"
  ) {
    this.activeActivitiesActivitySection = section;
  }

  openWhatsAppAndLogMessage(phoneNumber: string) {
    this.edit_action_mode = false;
    this.lead_id = this.leadDetails.id;
    this.logMessageModal.open();
    window.open("https://wa.me/" + phoneNumber, "_blank");
  }

  openPhoneAndLogCall(phoneNumber: string) {
    this.edit_action_mode = false;
    this.lead_id = this.leadDetails.id;
    this.logPhoneCallModal.open();
    window.open("tel:" + phoneNumber, "_blank");
  }

  openCallQrModal(phoneNumber: string) {
    const normalizedPhoneNumber = this.normalizePhoneNumber(phoneNumber);
    if (!normalizedPhoneNumber) {
      return;
    }

    this.selectedPhoneForQr = normalizedPhoneNumber;
    this.callQrDialUrl = `tel:${normalizedPhoneNumber}`;
    this.callQrCodeUrl =
      "https://api.qrserver.com/v1/create-qr-code/?size=280x280&data=" +
      encodeURIComponent(this.callQrDialUrl);
    this.callQrModal.open();
  }

  private normalizePhoneNumber(phoneNumber: string): string {
    const rawPhone =
      phoneNumber === null || phoneNumber === undefined
        ? ""
        : phoneNumber.toString().trim();
    if (!rawPhone) {
      return "";
    }

    const digitsOnly = rawPhone.replace(/\D/g, "");
    if (!digitsOnly) {
      return "";
    }

    return rawPhone.startsWith("+") ? `+${digitsOnly}` : digitsOnly;
  }

  // Helper method to check if a date is in the past
  isPastDate(dateString: string): boolean {
    if (!dateString || dateString === null || dateString === undefined) {
      return false;
    }
    try {
      return !this.isFutureDateTime(dateString);
    } catch (error) {
      console.error("Error checking if date is in past:", error);
      return false;
    }
  }

  // Date change handlers for modals
  onSetMeetingDateChange() {
    if (!this.setMeeting || !this.setMeeting.due_date) {
      this.showFeedbackInSetMeeting = false;
      return;
    }

    this.showFeedbackInSetMeeting = this.isPastDate(this.setMeeting.due_date);
    if (!this.showFeedbackInSetMeeting) {
      // Clear feedback fields when switching to future date
      this.setMeeting.feedback_status_id = null;
      this.setMeeting.event_status_id = null;
      this.setMeeting.feedback = null;
    }
  }

  onLogPhoneCallDateChange() {
    if (!this.logPhoneCall || !this.logPhoneCall.due_date) {
      this.showFeedbackInLogPhoneCall = false;
      return;
    }

    this.showFeedbackInLogPhoneCall = this.isPastDate(
      this.logPhoneCall.due_date
    );
    if (!this.showFeedbackInLogPhoneCall) {
      // Clear feedback fields when switching to future date
      this.logPhoneCall.feedback_status_id = null;
      this.logPhoneCall.event_status_id = null;
      this.logPhoneCall.feedback = null;
    }
  }

  onLogMessageDateChange() {
    if (!this.logMessage || !this.logMessage.due_date) {
      this.showFeedbackInLogMessage = false;
      return;
    }

    this.showFeedbackInLogMessage = this.isPastDate(this.logMessage.due_date);
    if (!this.showFeedbackInLogMessage) {
      // Clear feedback fields when switching to future date
      this.logMessage.feedback_status_id = null;
      this.logMessage.event_status_id = null;
      this.logMessage.feedback = null;
    }
  }


  setMeetingModalOpen() {
    const existing = new Date();
    this.setMeeting = this.setMeeting || {};
    delete this.setMeeting.mission_type;
    delete this.setMeeting.start_meeting_time;
    delete this.setMeeting.end_meeting_time;
    if (!this.setMeeting.due_date) {
      this.setMeeting.due_date = this.toLocalDatetimeLocal(existing);
    }
    // Reset feedback visibility and clear feedback fields
    this.showFeedbackInSetMeeting = false;
    this.setMeeting.feedback_status_id = null;
    this.setMeeting.event_status_id = null;
    this.setMeeting.feedback = null;
    this.onSetMeetingDateChange();
  }

  logPhoneCallModalOpen() {
    const existing = new Date();
    this.logPhoneCall = this.logPhoneCall || {};
    if (!this.logPhoneCall.due_date) {
      this.logPhoneCall.due_date = this.toLocalDatetimeLocal(existing);
    }
    // Reset feedback visibility and clear feedback fields
    this.showFeedbackInLogPhoneCall = false;
    this.logPhoneCall.feedback_status_id = null;
    this.logPhoneCall.event_status_id = null;
    this.logPhoneCall.feedback = null;
    this.onLogPhoneCallDateChange();
  }

  logMassageModalOpen() {
    const existing = new Date();
    this.logMessage = this.logMessage || {};
    if (!this.logMessage.due_date) {
      this.logMessage.due_date = this.toLocalDatetimeLocal(existing);
    }
    // Reset feedback visibility and clear feedback fields
    this.showFeedbackInLogMessage = false;
    this.logMessage.feedback_status_id = null;
    this.logMessage.event_status_id = null;
    this.logMessage.feedback = null;
    this.onLogMessageDateChange();
  }

  nextActionModalOpen() {
    const existing = new Date();
    this.nextAction = this.nextAction || {};
    this.nextAction.next_action_due_date = this.toLocalDatetimeLocal(existing);
    this.nextAction.next_action_mission_type = null;
    this.nextAction.next_action_start_meeting_time = null;
    this.nextAction.next_action_end_meeting_time = null;
  }

  openEditMeetingModal(modal: any, meeting: any) {
    this.setMeeting = {
      action_type: "meeting",
      meeting_type_id: meeting.meeting_type_id,
      due_date: meeting.due_date,
      event_status_id: meeting.event_status_id,
      notes: meeting.notes,
      has_next_action: false,
    };
    modal.open();
  }

  openEditPhoneLogModal(modal: any, phoneLog: any) {
    this.logPhoneCall = {
      action_type: "call",
      lead_action_id: phoneLog.id,
      call_type_id: phoneLog.call_type_id,
      due_date: phoneLog.due_date,
      notes: phoneLog.notes,
      has_next_action: false,
    };
    modal.open();
  }

  openEditMessageLogModal(modal: any, messageLog: any) {
    this.logMessage = removeNullishFieldsParams(messageLog);
    this.logMessage = {
      action_type: "message",
      message_source_id: messageLog.message_source_id,
      due_date: messageLog.due_date,
      notes: messageLog.notes,
      has_next_action: false,
    };
    modal.open();
  }

  validatePastActionFeedback(modalData: any): boolean {
    if (!modalData || !modalData.due_date || !this.isPastDate(modalData.due_date)) {
      return true;
    }

    if (!modalData.feedback_status_id) {
      swal(
        "Validation Error",
        "Feedback Status is required for past actions",
        "error"
      );
      return false;
    }

    if (!modalData.feedback || !String(modalData.feedback).trim()) {
      swal(
        "Validation Error",
        "Feedback is required for past actions",
        "error"
      );
      return false;
    }

    return true;
  }

  editAction(
    modal: any,
    nextActionModal: any,
    modalData: any,
    has_first_action?: boolean
  ) {
    if (!this.validatePastActionFeedback(modalData)) {
      return;
    }

    // Prepare payload - includes feedback fields (feedback_status_id, event_status_id, feedback) for past actions
    let payload;
    if (has_first_action) {
      payload = {
        ...this.firstAction,
        ...modalData,
      };
    } else {
      payload = modalData;
    }
    console.log(payload);
    if (modalData.has_next_action) {
      this.firstAction = modalData;
      modal.close();
      nextActionModal.open();
    } else {
      this.leadsService
        .editAction(this.leadDetails["id"], payload.lead_action_id, payload)
        .subscribe(
          (res: any) => {
            swal(res.message, "", "success");
            modal.close();
            if (isFutureDateTime(payload.due_date)) {
              this.reminder.title = payload.action_type;
              this.reminder.lead_action_id = res.action_type.id;
              this.reminder.details = payload.notes;
              this.reminder.reminder_datetime = payload.due_date;
              this.addReminder();
            }
            this.edit_action_mode = false;
            this.refreshLeadView();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
    }
  }

  setActionModalSubmit(
    modal: any,
    nextActionModal: any,
    modalData: any,
    has_first_action?: boolean
  ) {
    console.log("modalData:", modalData);
    console.log(modalData.due_date);
    console.log(this.isPastDate(modalData.due_date));

    if (!this.validatePastActionFeedback(modalData)) {
      return;
    }

    // Prepare payload - includes feedback fields (feedback_status_id, event_status_id, feedback) for past actions
    let payload;
    if (has_first_action) {
      payload = {
        ...this.firstAction,
        ...modalData,
      };
    } else {
      payload = modalData;
    }
    console.log(payload);
    if (modalData.has_next_action) {
      this.firstAction = modalData;
      modal.close();
      nextActionModal.open();
    } else {
      this.submitAction$.next({ modal, payload });
    }
  }

  AddFeedback(
    modal: any,
    nextActionModal: any,
    modalData: any,
    has_first_action?: boolean
  ) {
    console.log("modalData:", modalData);
    console.log(modalData.due_date);
    console.log(this.isPastDate(modalData.due_date));

    if (!this.validatePastActionFeedback(modalData)) {
      return;
    }

    // Prepare payload - includes feedback fields (feedback_status_id, event_status_id, feedback) for past actions
    let payload;
    if (has_first_action) {
      payload = {
        ...this.firstAction,
        ...modalData,
      };
    } else {
      payload = modalData;
    }
    console.log(payload);
    if (modalData.has_next_action) {
      this.firstAction = modalData;
      modal.close();
      nextActionModal.open();
    } else {
      this.submitFeedback$.next({ modal, payload });
    }
  }

  openFeedbackModal(modal: any, leadActionId: number) {
    this.feedback = {
      action_type: "feedback",
      feedback: null,
      lead_action_id: leadActionId,
      event_status_id: null,
      feedback_status_id: null,
      next_action_notes: null,
      has_next_action: false,
    };
    modal.open();
  }
}



// WEBPACK FOOTER //
// ./src/app/lead/dashboard/lead.component.ts